import { createReducer, on } from '@ngrx/store';
import { UsersActions, RouterActions } from '@actions/index'
import { UserModel, UserRolesModel, SentInvitationModel, UserBusinessModel } from '@models/index'
import { Injectable } from '@angular/core';
import { Role } from '@enums/role.enum';


export interface State {
    users: UserBusinessModel[] | any;
    error: string;
    foundUsersByQuery: UserModel[];
    userRoles: UserRolesModel[];
    sentInvitations: SentInvitationModel[];
    sentInvitationStates: string[];
    resentInvitation: boolean;
    count: number;
}

const initialState: State = {
    users: { count: 0, users: [] },
    error: "",
    foundUsersByQuery: [],
    userRoles: [],
    sentInvitations: [],
    sentInvitationStates: [],
    resentInvitation: false,
    count: 0
};

export const reducer = createReducer(
    initialState,
    on(UsersActions.searchUsersByBusiness, (state) => ({ ...state, users: [], count: 0 })),
    on(UsersActions.searchUsersByBusinessSuccess, (state, { users }) => ({ ...state, users })),
    on(UsersActions.searchAllUsers, (state) => ({ ...state, users: [], count: 0 })),
    on(UsersActions.searchAllUsersSuccess, (state, { users }) => ({
        ...state,
        users: users ? users.data : [],
        count: users ? users.total : 0
    })),
    on(UsersActions.searchUsersByReseller, (state,) => ({ ...state, users: [], count: 0 })),
    on(UsersActions.searchUsersByResellerSuccess, (state, { users }) => ({ ...state, users })),
    on(UsersActions.searchUserRolesSuccess, (state, { userRoles }) => ({ ...state, userRoles: userRoles })),
    // on(UsersActions.createUserSuccess, (state, { user }) => ({ ...state, users: [user, ...state.users] })),
    on(UsersActions.createSentInvitationSuccess, (state, { sentInvitation }) => ({ ...state, users: [sentInvitation, ...state.users] })),
    on(UsersActions.addRoleToUserToBusinessSuccess, (state, { user }) => ({
        ...state, users: state.users.find(item => user.user.id == item.user.id)
            ? state.users.map((item) => item.user.id == user.user.id
                ? user
                : item)
            : [user, ...state.users]
    })),
    on(UsersActions.addRoleToUserToResellerSuccess, (state, { user }) => ({
        ...state, users: state.users.find(item => user.user.id == item.user.id)
            ? state.users.map((item) => item.user.id == user.user.id
                ? user
                : item)
            : [user, ...state.users]
    })),
    on(UsersActions.usersError, (state, { error }) => ({ ...state, error: error })),
    on(UsersActions.searchUsersByQuerySuccess, (state, { foundUsers }) => ({ ...state, foundUsersByQuery: foundUsers })),
    on(UsersActions.searchSentInvitationsSuccess, (state, { sentInvitations }) => ({ ...state, sentInvitations: sentInvitations })),
    on(UsersActions.searchSentInvitationStatesSuccess, (state, { sentInvitationStates }) => ({ ...state, sentInvitationStates: sentInvitationStates })),
    on(UsersActions.clearUsersList, (state) => ({ ...state, users: [], count: 0 })),
    on(UsersActions.deleteUserSucces, (state, { userId }) => ({ ...state, users: state.users.filter(user => user.user.id !== userId) })),
    on(UsersActions.deleteUserFromResellerSuccess, (state, { userId }) => ({ ...state, users: state.users.filter(user => user.user.id !== userId) })),
    on(UsersActions.resendSentInvitation, (state) => ({ ...state, resentInvitation: false })),
    on(UsersActions.resendSentInvitationSuccess, (state, { sentInvitation }) => ({ ...state, resentInvitation: sentInvitation })),
    on(UsersActions.setResentInvitation, (state, { value }) => ({ ...state, resentInvitation: value })),
    on(UsersActions.editUserSuccess, (state, { user }) => ({
        ...state,
        users: state.users.map((item: UserBusinessModel) => {
            return item.user.id == user.id ? { ...item, user } : item
        })
    })),
    on(UsersActions.updateRoleSuccess, (state, { user }) => ({
        ...state,
        users: state.users.map((item: UserBusinessModel) => {
            return item.user.id == user.id ? {
                ...item,
                user,
            } : item
        })
    })),
    on(RouterActions.navigateAuth, () => ({ ...initialState })),
);

export const getUsers = (state: State) => state.users;
export const getError = (state: State) => state.error;
export const getFoundUsersByQuery = (state: State) => state.foundUsersByQuery;
export const getUserRoles = (state: State) => state.userRoles;
export const getSentInvitations = (state: State) => state.sentInvitations;
export const getResentInvitation = (state: State) => state.resentInvitation;
export const getSentInvitationStates = (state: State) => state.sentInvitationStates;
export const getSize = (state: State) => state.count;
